export const GET_BRANDS_DATA = "GET_BRANDS_DATA";
export const GET_BRANDS_DATA_SUCCESS = "GET_BRANDS_DATA_SUCCESS";
export const GET_BRANDS_DATA_FAILURE = "GET_BRANDS_DATA_FAILURE";

export const GET_MODELS_DATA = "GET_MODELS_DATA";
export const GET_MODELS_DATA_SUCCESS = "GET_MODELS_DATA_SUCCESS";
export const GET_MODELS_DATA_FAILURE = "GET_MODELS_DATA_FAILURE";

export const GET_VARIANTS_DATA = "GET_VARIANTS_DATA";
export const GET_VARIANTS_DATA_SUCCESS = "GET_VARIANTS_DATA_SUCCESS";
export const GET_VARIANTS_DATA_FAILURE = "GET_VARIANTS_DATA_FAILURE";

export const GET_DOCUMENT_TEMPLATE = "GET_DOCUMENT_TEMPLATE";
export const GET_DOCUMENT_TEMPLATE_SUCCESS = "GET_DOCUMENT_TEMPLATE_SUCCESS";
export const GET_DOCUMENT_TEMPLATE_FAILURE = "GET_DOCUMENT_TEMPLATE_FAILURE";

export const DELETE_VARIANTS_DATA = "DELETE_VARIANTS_DATA";
